module.exports = __webpack_public_path__ + "static/albert-einstein-cd0a0ee7f78c50279fa67927310c4521.jpg";